import React, { Fragment } from 'react';
import styled from 'styled-components';
import Modal from './Modal';

interface ModalErrorProps {
  isOpen: boolean,
  message: string,
  subMessage: string,
  onClose: () => void,
}

const ModalErrorWrap = styled.div`
.error-modal-message {
  display: block;
  margin: 14px 0 10px;
  font-size: 16px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: -0.4px;
  word-break: keep-all;
  white-space: pre-wrap;
  text-align: center;
  color: #ff4129;
}
.error-modal-sub-message {
  display: block;
  margin: 0 0 14px;
  font-size: 14px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: -0.4px;
  text-align: center;
  word-break: keep-all;
  white-space: pre-wrap;
  color: #666;
}
button.confirm-button {
  width: 100%;
  height: 48px;
  padding: 0;
  background-color: #333;
  border: unset;
  border-radius: 8px;
  font-size: 15px;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.2px;
  color: #fff;
}
  button.confirm-button:disabled {
    background-color: rgb(203,204,205);
  }
`;

const ModalError = ({
  isOpen,
  message,
  subMessage,
  onClose,
}:ModalErrorProps) => {
  return (
    <Fragment>
      <Modal
        isOpen={isOpen}
        isClosable={false}
        onClose={onClose}
        Content={(
          <ModalErrorWrap>
            <span className='error-modal-message'>
              {message}
            </span>
            <span className='error-modal-sub-message'>
              {subMessage}
            </span>
            <button className='confirm-button h-40 mb-14' onClick={onClose}>
              확인
            </button>
          </ModalErrorWrap>
        )}
      />
    </Fragment>
  );
};

export default ModalError;